import { parseServerDateTime } from 'src/utils/helpers/transformDate';

export const calcDuration = (data, key) => {
	if (!data[key]) return null;

	const from = parseServerDateTime(data[key]);

	if (!from) return null;

	const now = new Date();
	const diff = (now - from) / (1000 * 60 * 60 * 24);

	return Math.floor(diff);
};

export const calcUnsolvedObjectionsDuration = (objections) => {
	if (!objections) return null;

	if (!Array.isArray(objections)) {
		return objections.duration ?? null;
	}

	const unsolved = objections.filter((objection) => !objection.solved);

	if (!unsolved.length) return null;

	const oldestCreatedAt = unsolved.reduce((oldest, objection) => {
		if (!objection.createdAt) return oldest;

		const createdAt = parseServerDateTime(objection.createdAt);

		if (!createdAt) return oldest;

		return !oldest || createdAt < oldest ? createdAt : oldest;
	}, null);

	if (!oldestCreatedAt) return null;

	const now = new Date();
	const diff = (now - oldestCreatedAt) / (1000 * 60 * 60 * 24);

	return Math.floor(diff);
};
